import script from "./ViewManualAppraisalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewManualAppraisalPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewManualAppraisalPage.vue?vue&type=style&index=0&id=31d10a86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31d10a86"]])

export default __exports__